import { Button, Empty, Table } from "antd";
import React from "react";
import useTableSearch from "../../../hooks/useTableSearch";
import moment from "moment";

export const TarifTable = ({ setEditTarif, tarifs }) => {
  const getColumnSearchProps = useTableSearch();

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id.localeCompare(b.id),
      ...getColumnSearchProps("id"),
    },
    {
      title: "SERVICE",
      dataIndex: ["SERVICE", "NAMESERVIC"],
      key: "SERVICEID",
      sorter: (a, b) => (a.SERVICEID > b.SERVICEID ? -1 : 1),
      ...getColumnSearchProps("SERVICEID"),
    },

    {
      title: "Tarif",
      dataIndex: "value",
      key: "value",
      sorter: (a, b) => (a.value > b.value ? -1 : 1),
      ...getColumnSearchProps("value"),
    },
    {
      title: "Data de incepere",
      dataIndex: "startDate",
      key: "startDate",
      sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
      render: (text) => (
        <span>
          {moment(text).tz("Europe/Chisinau").format("DD/MM/YYYY, HH:mm")}
        </span>
      ),
      ...getColumnSearchProps("startDate"),
    },
    {
      title: "Data finala",
      dataIndex: "endDate",
      key: "endDate",
      sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
      render: (text) => (
        <span>
          {moment(text).tz("Europe/Chisinau").format("DD/MM/YYYY, HH:mm")}
        </span>
      ),
      ...getColumnSearchProps("endDate"),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      ...getColumnSearchProps("description"),
    },
    {
      title: "Actiuni",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <Button onClick={() => setEditTarif(record.id)}>Edit</Button>
      ),
    },
  ];
  return (
    <div>
      {" "}
      <Table
        locale={{
          triggerDesc: "Faceți clic pentru a sorta descrescător",
          triggerAsc: "Faceți clic pentru a sorta crescător",
          cancelSort: "Faceți clic pentru a anula sortarea",
          emptyText: <Empty description={"Nu există date"}></Empty>,
        }}
        scroll={{ x: 900 }}
        columns={columns}
        rowKey={"id"}
        dataSource={tarifs}
      />
    </div>
  );
};
